import { Icon, IconProps } from '@chakra-ui/react'
import { BsArrowLeft } from 'react-icons/bs'

export function ArrowLeftIcon(props: IconProps) {
  return <Icon as={BsArrowLeft} {...props} />
}
